import Component from '../../../shared/component';

export default class AvatarBuilderSaveControl extends Component {
  constructor(element, opts) {
    super(...arguments);

    this.$element = $(element);

    this.$saveControl = this.$element.children(
      '.menteeAvatarBuilderModal-footer-link--save'
    );
    this.$savingMessage = this.$element.children(
      '.menteeAvatarBuilderModal-footer-link--saving'
    );
    this.$savedMessage = this.$element.children(
      '.menteeAvatarBuilderModal-footer-link--saved'
    );
    this.$loadingMessage = this.$element.children(
      '.menteeAvatarBuilderModal-footer-link--loading'
    );

    this.avatarBuilder = opts.avatarBuilder;

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$saveControl.on('click.AvatarBuilderSaveControl', this.handleClick);
  }

  unbindEvents() {
    this.$saveControl.off('click.AvatarBuilderSaveControl', this.handleClick);
  }

  handleClick() {
    if (this.avatarBuilder.previewMode === 'live') this.displaySaving();
    this.avatarBuilder.updateConfiguration();
  }

  handleSaved() {
    this.displaySaved();
  }

  displayLoading() {
    this.$loadingMessage.show();
    this.$saveControl.hide();
    this.$savedMessage.hide();
    this.$savingMessage.hide();
    this.$element.removeClass('menteeAvatarBuilderModal-footer--success');
  }

  displayReady() {
    this.$loadingMessage.hide();
    this.$saveControl.show();
    this.$savedMessage.hide();
    this.$savingMessage.hide();
    this.$element.removeClass('menteeAvatarBuilderModal-footer--success');
  }

  displaySaving() {
    this.$loadingMessage.hide();
    this.$saveControl.hide();
    this.$savedMessage.hide();
    this.$savingMessage.show();
    this.$element.removeClass('menteeAvatarBuilderModal-footer--success');
  }

  displaySaved() {
    this.$loadingMessage.hide();
    this.$saveControl.hide();
    this.$savedMessage.show();
    this.$savingMessage.hide();
    this.$element.addClass('menteeAvatarBuilderModal-footer--success');
  }

  hideLoading() {
    this.$loadingMessage.hide();
  }
}
